import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GlobalScope_instance3t6qd3g1xr5c0 as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import {
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  NoContent1bdx48poqrifq as NoContent,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { Companion_getInstance16dzvgcii8pc4 as Companion_getInstance } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { UnsupportedContentTypeException1omj39t4jp3a7 as UnsupportedContentTypeException } from '../call/utils.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { observable2pw4p3n7s3klf as observable } from '../utils/ByteChannelUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getContent($this, delegate) {
  var tmp;
  if (delegate instanceof ContentWrapper()) {
    tmp = getContent($this, delegate.j56());
  } else {
    if (delegate instanceof ByteArrayContent()) {
      tmp = ByteReadChannel(delegate.a56());
    } else {
      if (delegate instanceof ProtocolUpgrade()) {
        throw UnsupportedContentTypeException().t5k(delegate);
      } else {
        if (delegate instanceof NoContent()) {
          tmp = Companion_getInstance().y4j_1;
        } else {
          if (delegate instanceof ReadChannelContent()) {
            tmp = delegate.d56();
          } else {
            if (delegate instanceof WriteChannelContent()) {
              var tmp_0 = GlobalScope_instance;
              tmp = writer(tmp_0, $this.w5k_1, true, ObservableContent$getContent$slambda_0(delegate)).e4k_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
var ObservableContent$getContent$slambdaClass;
function ObservableContent$getContent$slambda() {
  if (ObservableContent$getContent$slambdaClass === VOID) {
    class $ {
      constructor($delegate) {
        this.y5k_1 = $delegate;
      }
      *p58($this$writer, $completion) {
        yield* this.y5k_1.f56($this$writer.g4k_1, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.p58(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ObservableContent$getContent$slambdaClass = $;
  }
  return ObservableContent$getContent$slambdaClass;
}
function ObservableContent$getContent$slambda_0($delegate) {
  var i = new (ObservableContent$getContent$slambda())($delegate);
  var l = ($this$writer, $completion) => i.p58($this$writer, $completion);
  l.$arity = 1;
  return l;
}
var ObservableContentClass;
function ObservableContent() {
  if (ObservableContentClass === VOID) {
    class $ extends ReadChannelContent() {
      constructor(delegate, callContext, listener) {
        super();
        this.v5k_1 = delegate;
        this.w5k_1 = callContext;
        this.x5k_1 = listener;
      }
      k47() {
        return this.v5k_1.k47();
      }
      l47() {
        return this.v5k_1.l47();
      }
      f50() {
        return this.v5k_1.f50();
      }
      d56() {
        return observable(getContent(this, this.v5k_1), this.w5k_1, this.l47(), this.x5k_1);
      }
    }
    initMetadataForClass($, 'ObservableContent');
    ObservableContentClass = $;
  }
  return ObservableContentClass;
}
var ProgressListenerClass;
function ProgressListener() {
  if (ProgressListenerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProgressListener', VOID, VOID, VOID, [2]);
    ProgressListenerClass = $;
  }
  return ProgressListenerClass;
}
//region block: exports
export {
  ObservableContent as ObservableContent3ft2pt0w2oysd,
  ProgressListener as ProgressListener886sg277haqw,
};
//endregion

//# sourceMappingURL=ObservableContent.mjs.map
